export default __webpack_public_path__ + "static/media/table-noservice.cf4f8c59.svg";